module.exports = __webpack_public_path__ + "img/Paso 3.4d22f1b6.png";